import { CalendarDayGridBase } from './CalendarDayGrid.base';
import { styles } from './CalendarDayGrid.styles';
import { styled } from '../../Utilities';
export var CalendarDayGrid = styled(CalendarDayGridBase, styles, undefined, {
  scope: 'CalendarDayGrid'
});